import { useEffect, useState } from "react";
import API from "../../../services/api";
import "./ClassTestList.css";

export default function ClassTestList() {
  const [tests, setTests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState(null);

  // =========================
  // FETCH TESTS
  // =========================
  const fetchTests = async () => {
    try {
      setLoading(true);

      const schoolData = JSON.parse(localStorage.getItem("schoolAdmin"));

      const schoolCode = schoolData?.school?.subdomain;

      const res = await API.get(
        `/class-test/admin-list/?school_code=${schoolCode}`,
      );

      setTests(res.data.tests || []);
    } catch (err) {
      console.error("❌ Error fetching tests:", err);
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // FETCH DETAILS
  // =========================
  const fetchDetails = async (id) => {
    try {
      const schoolData = JSON.parse(localStorage.getItem("schoolAdmin"));

      const schoolId = schoolData?.school?.id;

      const res = await API.get(`/class-test/admin-list/${id}/`, {
        headers: {
          "X-SCHOOL-ID": schoolId,
        },
      });

      setDetails(res.data);
    } catch (err) {
      console.error("❌ Error fetching details:", err);
    }
  };

  // =========================
  // DELETE TEST
  // =========================
  const deleteTest = async (id) => {
    const confirmDelete = window.confirm("Delete this class test?");

    if (!confirmDelete) return;

    try {
      const schoolData = JSON.parse(localStorage.getItem("schoolAdmin"));

      const schoolId = schoolData?.school?.id;

      await API.delete(`/class-test/delete/${id}/`, {
        headers: {
          "X-SCHOOL-ID": schoolId,
        },
      });

      alert("Class test deleted");

      if (details?.id === id) {
        setDetails(null);
      }

      fetchTests();
    } catch (err) {
      console.error(err);
      alert("Failed to delete class test");
    }
  };

  // =========================
  // DOWNLOAD REPORT
  // =========================
 const downloadReport = async (id) => {
  try {

    const schoolData = JSON.parse(
      localStorage.getItem("schoolAdmin")
    );

    const schoolId =
      schoolData?.school?.id;

    const response = await API.get(
      `/class-test/report/${id}/`,
      {
        responseType: "blob",

        headers: {
          "X-SCHOOL-ID": schoolId,
        },
      }
    );

    const url = window.URL.createObjectURL(
      new Blob([response.data])
    );

    const link = document.createElement("a");

    link.href = url;

    link.setAttribute(
      "download",
      `class_test_report_${id}.pdf`
    );

    document.body.appendChild(link);

    link.click();

    link.remove();

  } catch (err) {
    console.error(err);
    alert("Failed to download report");
  }
};
  useEffect(() => {
    fetchTests();
  }, []);

  return (
    <div className="class-test-page">
      {/* HEADER */}
      <div className="header-row">
        <div>
          <h2 className="title">Class Tests</h2>
          <p className="subtitle">View, download and manage class tests.</p>
        </div>
      </div>

      {loading ? (
        <div className="loading">Loading class tests...</div>
      ) : tests.length === 0 ? (
        <div className="empty">
          <div className="empty-icon">A+</div>
          <h4>No class tests found</h4>
          <p>Class test records will appear here after teachers add results.</p>
        </div>
      ) : (
        <div className="card">
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Class</th>
                <th>Section</th>
                <th>Subject</th>
                <th>Test Name</th>
                <th>Teacher</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {tests.map((t) => (
                <tr key={t.id} className="row">
                  <td onClick={() => fetchDetails(t.id)}>{t.date}</td>

                  <td onClick={() => fetchDetails(t.id)}>{t.class_name}</td>

                  <td onClick={() => fetchDetails(t.id)}>{t.section}</td>

                  <td onClick={() => fetchDetails(t.id)}>{t.subject}</td>

                  <td onClick={() => fetchDetails(t.id)}>{t.test_name}</td>

                  <td onClick={() => fetchDetails(t.id)}>{t.teacher_name}</td>

                  {/* ACTIONS */}
                  <td>
                    <div className="action-buttons">
                      <button
                        className="btn-report"
                        onClick={() => downloadReport(t.id)}
                      >
                        Download
                      </button>

                      <button
                        className="btn-report"
                        onClick={() => deleteTest(t.id)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* DETAILS */}
      {details && (
        <div className="details">
          <div className="details-header">
            <h3>Test Details</h3>

            <button className="close-btn" onClick={() => setDetails(null)}>
              ✕
            </button>
          </div>

          <div className="info">
            <p>
              <b>Test:</b> {details.test_name}
            </p>
            <p>
              <b>Subject:</b> {details.subject}
            </p>
            <p>
              <b>Date:</b> {details.date}
            </p>
            <p>
              <b>Teacher:</b> {details.teacher_name}
            </p>
            <p>
              <b>Class:</b> {details.class_name}
            </p>
            <p>
              <b>Section:</b> {details.section}
            </p>
          </div>

          <h4>Students</h4>

          <table className="table small">
            <thead>
              <tr>
                <th>Name</th>
                <th>ID</th>
                <th>Marks</th>
              </tr>
            </thead>

            <tbody>
              {details.results.map((r, i) => (
                <tr key={i}>
                  <td>{r.student_name}</td>
                  <td>{r.student_id}</td>
                  <td>{r.marks}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
